
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from 'react';
import Link from 'next/link';
import Item, { ItemUl, ItemText, ItemBottom } from 'library/molecules/Item';
import { Text, H2, H4 } from 'library/atoms/Typography';
import Layout from 'library/atoms/Layout';
import widgetRoutes from 'enums/routes';
import { definedNotNull } from 'shared/presenters/presenter';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { OutletPresenter } from 'shared/presenters';
import Header from 'library/molecules/Header';
import Breadcrumbs from 'library/molecules/Breadcrumb';
import { VoucherCard } from 'helpers/determineVouchers';
import { Outlets } from 'shared/presenters/graphqlTypes';
import CoverImage from 'library/atoms/CoverImage';
import { CREDIT_VOUCHER_MIN_PRICE_PENCE, CREDIT_VOUCHER_TITLE } from 'enums/vouchers';
import InfoBar from 'library/molecules/InfoBar';
import ModalRedeemVoucher from 'library/molecules/ModalRedeemVoucher';
import useBasket from 'state/useBasket';
import useAssignPriceModifier from 'state/useAssignPriceModifier';
import useRemovePriceModifier from 'state/useRemovePriceModifier';
import usePageRouter from 'shared/state/usePageRouter';
import { StyledTagsList } from 'library/molecules/SchedulableCard';
import PurchasableCardPrice from 'library/molecules/PurchasableCardPrice';
import HeadContainer from 'library/atoms/HeadContainer';
export interface VouchersProps {
    outlet: Outlets;
    vouchers: VoucherCard[];
}
const Vouchers = ({ outlet: outletJSON, vouchers }: VouchersProps) => {
    const { query } = useRouter();
    const widgetSlug = query.widgetSlug as string;
    const outlet = new OutletPresenter(outletJSON);
    const { t } = useTranslation('chargeable');
    const [modalOpen, setModalOpen] = useState(false);
    const { basket } = useBasket();
    const { setActiveModalId } = usePageRouter();
    const breadcrumbs = [
        {
            link: widgetRoutes.HOME.url({ widgetSlug }),
            name: definedNotNull(outlet.name),
            image: outlet.logoImageURL()
        },
        {
            link: widgetRoutes.VOUCHERS.url({ widgetSlug }),
            name: t('common:vouchers-and-passes'),
            image: '',
            currentPage: true
        }
    ];
    const { redeemCode, redeemCodeLoading, redeemCodeError } = useAssignPriceModifier({
        changeViewOnSuccess: () => setActiveModalId(null)
    });
    const { removePriceModifier } = useRemovePriceModifier();
    return (<>
      <HeadContainer title={t('vouchers-and-passes-for', { outlet: outlet.name })} description={t('vouchers-and-passes-description', {
            outlet: outlet.name
        })}>
        {!outlet.feature_toggles?.marketplace_enabled && (<meta name="robots" content="noindex"/>)}
      </HeadContainer>
      <Layout variant="wide">
        <Header />
        <Breadcrumbs pages={breadcrumbs} firstLinkAsHome={true}/>

        <main>
          <H2 mb={4}>
            {t('x-vouchers-available', { count: vouchers.length })}
          </H2>
          <ItemUl variant="grid">
            {/**
         *
         * Redeem code to apply price modifier
         *
         */}
            <InfoBar variant="feature" icon="voucher" onClick={() => {
            setModalOpen(true);
        }}>
              {t('i-have-voucher')}
            </InfoBar>
            {vouchers?.map(voucher => {
            return (<Link key={voucher.id} href={voucher.href} passHref legacyBehavior>
                  <Item variant="card" title={t('common:view-item-name', {
                    itemName: definedNotNull(voucher.name)
                })}>
                    <CoverImage height={250} src={voucher.image}/>
                    <ItemText>
                      <H4>{voucher.name}</H4>
                    </ItemText>
                    <ItemText>
                      <StyledTagsList>
                        <Text size="sm" fontstyle="p3" color="secondary">
                          {voucher.id === CREDIT_VOUCHER_TITLE
                    ? t('common:voucher')
                    : t('common:pass')}
                        </Text>
                      </StyledTagsList>
                    </ItemText>
                    <ItemText>
                      {voucher.tagline && (<Text mb={3} color="secondary" size={'sm'}>
                          {voucher.tagline}
                        </Text>)}
                    </ItemText>
                    <ItemBottom>
                      <ItemText>
                        <PurchasableCardPrice pence={voucher.id === CREDIT_VOUCHER_TITLE
                    ? CREDIT_VOUCHER_MIN_PRICE_PENCE
                    : definedNotNull(voucher.price_pence)} currency={outlet.currency()}/>
                      </ItemText>
                    </ItemBottom>
                  </Item>
                </Link>);
        })}
          </ItemUl>
        </main>
        <ModalRedeemVoucher onClose={() => {
            setModalOpen(false);
        }} isOpen={modalOpen} outlet={outlet} outletId={definedNotNull(outlet?.id)} basketId={basket?.id} redeemCode={redeemCode} redeemCodeLoading={redeemCodeLoading} redeemCodeError={redeemCodeError} removePriceModifier={removePriceModifier}/>
      </Layout>
    </>);
};
export default Vouchers;

    async function __Next_Translate__getStaticProps__196f365a822__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Vouchers/Vouchers',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196f365a822__ as getStaticProps }
  